/*
 * mod='role'
 * author: nicy
 * time: 2019-02-21
 */

import { smb_fetch, getAgpApiUrl as getApiUrl, getAgsApiUrl } from '../../../fetch';
import { isOa } from '@/utils/index';
import { EventCodeMap, UNKNOWN_EVENT_CODE } from '@/constants/user-behavior';
import md5 from 'crypto-js/md5';

/**
 * 新增自定义列
 * @return
 */
export const createColumns = (data, isShowError) => {
  const url = getApiUrl('customized_column', 'create_column');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取用户自定义
 * @return
 */
export const updateColumns = (data, isShowError) => {
  const url = getApiUrl('customized_column', 'update_column');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 删除自定义列
 * @return
 */
export const deleteColumns = (data, isShowError) => {
  const url = getApiUrl('customized_column', 'delete_column');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 设置默认展示自定义列
 * @return
 */
export const updateDefaultColumn = (data, isShowError) => {
  const url = getApiUrl('customized_column', 'update_default_column');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 查询自定义列
 * @return
 */
export const getColumns = (data, isShowError, isCache = true) => {
  const url = getApiUrl('customized_column', 'get_column');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取用户的所有标签
 * @return
 */
export const getLabels = (data) => {
  const url = getApiUrl('customized_label', 'get_label_type_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 用户行为上报
 * @param {*} data 数据
 * @param {*} useSendBeacon 是否使用navigator.sendBeacon上报，以收集页面关闭时的数据
 * @returns
 */
export const reportUserBehaviorCgi = (data, { useSendBeacon = false } = {}) => {
  if (isOa()) {
    return Promise.resolve();
  }
  // 替换掉特殊的字符/\'
  const replaceCharacter = (params) => {
    return params ? `${params}`.replace(/\'/g, `${escape('\'')}`).replace(/\//g, `${encodeURIComponent('/')}`)
      .replace(/\\/g, escape('\\')) : null;
  };
  const url = getApiUrl('monitor', 'report_behavior');
  const params = $.extend(
    true,
    {
      method: 'POST',
      useSendBeacon,
    },
    {
      ...data,
      data: {
        ...data?.data,
        relation_id: replaceCharacter(data?.data?.relation_id),
        relation_type: replaceCharacter(data?.data?.relation_type),
        relation_name: replaceCharacter(data?.data?.relation_name),
        field1: EventCodeMap[data.data.behavior] || UNKNOWN_EVENT_CODE,
        field2: getUuid() || undefined,
      },
    },
  );
  return smb_fetch(url, params, false);
};

const UUID_STORAGE_NAME = 'CLIENT_UUID';
// 获取设备标识
export function getUuid() {
  try {
    let uuid = localStorage.getItem(UUID_STORAGE_NAME);
    if (!uuid) {
      uuid = md5(`${Date.now()}_${parseInt(Math.random() * 1000000000000, 10)}_abcd_${parseInt(Math.random() * 1000000000000, 10)}`).toString();
      localStorage.setItem(UUID_STORAGE_NAME, uuid);
    }
    return uuid;
  } catch(e) {
    console.error(e);
    return '';
  }
}


/**
 * 用户行为上报 for sale
 * @author fightingliu
 * @param {*} data 数据
 * @param {*} useSendBeacon 是否使用navigator.sendBeacon上报，以收集页面关闭时的数据
 * @param {*} isPageInit 是否是首次进入页面
 * @returns
 */
export const reportSaleUserBehaviorCgi = (data) => {
  if (isOa()) {
    return Promise.resolve();
  }
  const url = getAgsApiUrl('report', 'behaviorPrivateLead'); // 新的销售上报接口
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      ...data,
      data: {
        ...data?.data,
      },
    },
  );
  return smb_fetch(url, params, false, false);
};


/**
 * 用户行为上报 for 通用
 * @author fightingliu
 * @param {*} data 数据
 * @param {*} useSendBeacon 是否使用navigator.sendBeacon上报，以收集页面关闭时的数据
 * @param {*} isPageInit 是否是首次进入页面
 * @returns
 */
export const reportSeasUserBehaviorCgi = (data) => {
  if (isOa()) {
    return Promise.resolve();
  }
  const url = getAgsApiUrl('report', 'reportBury'); // 通用上报接口公海上报接口
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    {
      ...data,
      data: {
        ...data?.data,
      },
    },
  );
  return smb_fetch(url, params, false, false);
};
/**
 * 获取登录员工的信息
 * @return
 */

export const getAccountInfo = (data) => {
  const url = getApiUrl('auth', 'get_user');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取账户列表
 * @return
 */

export const getAccountList = (data) => {
  const url = getApiUrl('auth', 'get_login_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 已读协议
 * @return
 */

export const readAgreement = (data) => {
  const url = getApiUrl('agency', 'accept_agreement');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 查询单个服务商的所有子客BM列表
 * @return
 */

export const getBmList = (data) => {
  const url = getApiUrl('bm_advertiser', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 退出登录
 * @return
 */
export const logout = (data) => {
  const url = getApiUrl('auth', 'logout');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

export const labelBatchUpdate = (data) => {
  const url = getApiUrl('customized_label', 'batch_update');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

export const getEduLoginUrl = (data) => {
  const url = getApiUrl('edu', 'get_login_url');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

export const getAreaInfo = (data) => {
  const url = getApiUrl('finance', 'area-info');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

export const getFeatureFlagList = (data) => {
  const url = getApiUrl('auth', 'get_feature_flag_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

export const getUserId = (data) => {
  const url = getApiUrl('eservice/pre_audit', 'get_userid');
  return smb_fetch(url, {
    method: 'GET',
    data,
  }, false, false);
};

export default {
  getColumns,
  getLabels,
  createColumns,
  updateColumns,
  deleteColumns,
  updateDefaultColumn,
  getAreaInfo,
  getEduLoginUrl,
  getFeatureFlagList,
};
